export default function spacerWidget(editor) {
  editor.DomComponents.addType('eb-spacer', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-spacer'
    },
    model: {
      defaults: {
        name: 'Spacer',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-spacer' },
        style: {
          'height': '50px',
          'width': '100%',
        },
        traits: [
          {
            type: 'number',
            name: 'data-height',
            label: 'Height (px)',
            changeProp: true,
            default: 50,
            min: 10,
            max: 500,
          },
        ],
      },
      init() {
        this.on('change:attributes:data-height', this.updateHeight)
      },
      updateHeight() {
        const h = this.getAttributes()['data-height'] || 50
        this.addStyle({ height: h + 'px' })
      },
    },
  })

  editor.BlockManager.add('eb-spacer', {
    label: 'Spacer',
    category: 'Basic',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M8 18h3v-2H8v2ZM8 8H11V6H8v2ZM4 4v16h16V4H4Zm14 14H6V6h12v12Z"/></svg>',
    content: { type: 'eb-spacer' },
  })
}
